
export enum ProductSelectionNotice {
    /**选型参数变化 */
    CheckParamsChange = 'check_params_change',
    /**选中参数重置 */
    CheckParamsClear = 'check_params_clear',
    /**产品选型确认 */
    LectotypeDimension = 'lectotype_dimension',
    /**添加到库 */
    LectoAddToLibrary = 'lecto_add_to_library',
    /**企业详情 */
    CompDetail = 'comp_detail',
}

export enum IframePostMessage {
    NeIframeAgent = 'ne_iframe_agent',
    // 天准
    NeIframeAgentTianZhun = 'tianzhun',
    NeIframeAgentTianZhunPlugin = 'plugin',
    NeIframeAgentTianZhunAdmin = 'admin',
}
